import { render, staticRenderFns } from "./JsaView.vue?vue&type=template&id=11077c64"
import script from "./JsaView.vue?vue&type=script&lang=js"
export * from "./JsaView.vue?vue&type=script&lang=js"
import style0 from "./JsaView.vue?vue&type=style&index=0&id=11077c64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports